export const getWWBagelsPackage = newProduct => {
  let newWWBagelsPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
    WholeWheatCert: newProduct.WholeWheatCert,
  }

  return newWWBagelsPackage
}

export const updateWWBagelsPackage = newProduct => {
  let newWWBagelsPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
    WholeWheatCert: newProduct.WholeWheatCert,
  }

  return newWWBagelsPackage
}
